import React from 'react'
import { ConfigurablePropsFromDescription } from '../../../helpers/widget'

export const configOptions = [
  {
    name: 'query',
    type: 'yasgui',
    label: 'Query that gives information of images. This query should return variables `?src_URL ?bottomLabel ?topLabel`, where ?src_URL (mandatory) is the URL to the image, and ?bottomLabel (option) and ?topLabel (optional) are text labels for the image.',
  },
  {
    name: 'textLoading',
    type: 'text',
    label: 'text when loading',
  },
  {
    name: 'textNoResults',
    type: 'text',
    label: 'text when no results',
  },
  {
    name: 'columnCount',
    type: 'text',
    label: 'number of columns',
  },
  {
    name: 'textErrorLoading',
    type: 'text',
    label: 'text when error loading results',
  },
  {
    name: 'deletionRule',
    type: 'text',
    label: 'rule triggered when requesting delete',
  },
  {
    name: 'deletionRuleParamsJSON',
    type: 'json-text',
    label: 'parameters for the rulechain, for example {"graph":"{{graph}}"}',
  },
  {
    name: 'showFullscreenLabel',
    type: 'boolean',
    label: 'Show image labels in fullscreen mode',
  },
  {
    name: 'fullscreenObjectFit',
    type: 'select',
    label: 'How to align and size the fullscreen image in its container. See here for more info: https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit#try_it',
    options: [
      { label: 'contain', value: 'contain' },
      { label: 'cover', value: 'cover' },
      { label: 'fill', value: 'fill' },
      { label: 'scale-down', value: 'scale-down' },
      { label: 'none', value: 'none' },
    ]
  },
  {
    name: 'labelTextAlign',
    type: 'select',
    label: 'Choose how the text are aligned in the image labels',
    options: [
      {
        label: 'center',
        value: 'center',
      },
      {
        label: 'left',
        value: 'left',
      },
      {
        label: 'right',
        value: 'right',
      }
    ],
  }
] as const

export type ImageGalleryWidgetDescription = ConfigurablePropsFromDescription<typeof configOptions>

export const imageGalleryWidgetDescription = {
  name: 'Image Gallery',
  component: React.lazy(() => import('./ImageGallery')),
  label: 'Image Gallery [Temporary]',
  variables: configOptions,
}
